import { StateCreator } from "zustand";
import { TabNames } from "@publicPortal/utils/enums";

export interface SearchTabsSlice {
    searchTab: TabNames;
    setSearchTab: (tab: TabNames) => void;
}

const initialSearchTabState: TabNames = TabNames["Property Search"];

export const createSearchTabsSlice: StateCreator<SearchTabsSlice, [], [], SearchTabsSlice> = (set) => ({
    searchTab: initialSearchTabState,
    setSearchTab: (tab) => set({ searchTab: tab }),
});

